import { reportError } from 'automation-ui-core/errors/utils/reportError';
import * as AssociationCategory from 'automation-ui-associations/constants/AssociationCategory';
const MIGRATED_ASSOCIATION_TYPE_IDS = {
  305: 387,
  306: 388,
  307: 389,
  308: 390,
  309: 391,
  310: 392,
  311: 395,
  313: 397,
  314: 398
};
function getEquivalentAssociationTypeId(associationCategory, associationTypeId) {
  if (associationCategory === AssociationCategory.HUBSPOT_DEFINED) {
    return MIGRATED_ASSOCIATION_TYPE_IDS[associationTypeId] || associationTypeId;
  } else {
    return associationTypeId;
  }
}
export default function findAssociationDefinitionFromSpec(associationSpec, associationDefinitionsQuery) {
  if (!associationSpec) {
    return null;
  }
  const associationCategory = associationSpec.getAssociationCategory();
  const associationTypeId = associationSpec.getAssociationTypeId();
  const equivalentAssociationTypeId = getEquivalentAssociationTypeId(associationCategory, associationTypeId);
  const definition = associationDefinitionsQuery.data.allDefinitions.find(associationDefinition => {
    return associationDefinition.id === equivalentAssociationTypeId && associationDefinition.category === associationCategory;
  });
  if (!definition && !associationDefinitionsQuery.loading && !associationDefinitionsQuery.error && associationCategory === AssociationCategory.HUBSPOT_DEFINED) {
    // Default associations are defined by the BE. If we're missing one,
    // there's a bug on the Associations BE API and we should reach out
    reportError({
      error: new Error('Missing HubSpot-defined association definition'),
      tags: {
        associationTypeId: `${associationTypeId}`
      }
    });
  }
  return definition;
}